import { XComLogsSearchSettingState } from "@/Administration/Components/XComLogs/XComLogsSearchSetting";
import * as LocalOperations from "@/Common/Operations/operations.local";
import { LocalEvent } from "@/Common/Stores/Actions/LocalEvent";
import { BaseOperationHandler } from "@/Common/Stores/Handlers/Local/BaseOperationHandler";
import { AdministrationStore } from "../../AdministrationStore";

class AdministrationXComLogHandler extends BaseOperationHandler {
    constructor() {
        super();
        this.RegisterOperation(LocalOperations.AdministrationXComLogs.SearchSettingsApplied, this.searchSettingsApplied);
        this.RegisterOperation(LocalOperations.AdministrationXComLogs.SearchSettings_SearchTextChanged, this.searchTextChanged);
        this.RegisterOperation(LocalOperations.AdministrationXComLogs.OnPageChange, this.onPageChange);
    }

    private searchSettingsApplied(request: LocalEvent, store: AdministrationStore): void {
        const xComLogsSettings = request.Get<XComLogsSearchSettingState>("settings");

        store.XComLogGridModel = store.XComLogGridModel
            .set("DateFrom", xComLogsSettings.DateFrom)
            .set("DateTo", xComLogsSettings.DateTo)
            .set("EventTypes", xComLogsSettings.EventTypes.filter(p => p.Checked).map(p => p.Model).toImmutable())
            .set("FileTypes", xComLogsSettings.FileTypes.filter(p => p.Checked).map(p => p.Model).toImmutable())
            .set("EventDirections", xComLogsSettings.EventDirection.filter(p => p.Checked).map(p => p.Model).toImmutable())
            .set("Options", xComLogsSettings.Options.filter(p => p.Checked).map(p => p.Model).toImmutable())
            .set("PageSize", xComLogsSettings.PageSize);
    }

    private searchTextChanged(request: LocalEvent, store: AdministrationStore): void {
        const value = request.Get<string>("filterText");
        store.XComLogGridModel = store.XComLogGridModel.set("SearchText", value);
    }

    private onPageChange(request: LocalEvent, store: AdministrationStore): void {
        var value = request.Get<number>("Page");
        store.XComLogGridModel = store.XComLogGridModel.set("PageSelected", value);
    }
}

export { AdministrationXComLogHandler };
